import { useEffect, useRef } from "react";

export const useDebouncedEffect = (effect, deps, delay) => {
	const didMount = useRef(false);

	useEffect(() => {
		if (didMount.current) {
			const handler = setTimeout(() => effect(), delay);
			return () => clearTimeout(handler);
		} else didMount.current = true;
	}, [...(deps || []), delay]);
};
